// ** Auth Endpoints
export default {
  loginEndpoint: "/api/users/login",
  registerEndpoint: "/api/users/register",
  refreshEndpoint: "/api/users/refresh-token",
  logoutEndpoint: "/api/users/logout",

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",
};
